import React from 'react';

function TextIcon({ icon, text, textStyle, className, ...props }) {
	return (
		<div style={{ display: 'flex' }} className={className}>
			<div className='mb-1'>{icon}</div>
			<span className='my-auto' style={{ fontFamily: 'Lato', ...textStyle }} {...props}>
				{text}
			</span>
		</div>
	);
}

export default TextIcon;
